/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './batch.tpl.html';
import './bulkRestore/details/bulkRestoreDetails.js';
import './bulkRestore/info/bulkRestoreInfo.tpl.html';
import './details/Details.js';
import './export/details/exportDetails.tpl.html';
import './export/info/exportInfo.tpl.html';
import './info/info.tpl.html';
import './messages/messages.tpl.html';
import './objectRestore/details/objectRestoreDetails.tpl.html';
import './objectRestore/info/objectRestoreInfo.tpl.html';

angular
  .module('mobile.batch', [
    'ui.router',
    'batch.export.details',
    'batch.export.info',
    'batch.info',
    'batch.navigator',
    'batch.objectRestore.details',
    'batch.objectRestore.info',
    'batch.bulkrestore.info',
    'batch.bulkrestore.navigator',
    'mobile.batch.bulkRestore.details',
    'mobile.batch.details',
    'batch.messages',
    'sbsf.constants'
  ])
  // This defines the main abstract main view that is shared across all
  // subviews.
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      /**
       * Utility function used to specify a batch value that must be populated prior to loading the state.
       * It will ensure that the batchUtils.currentBatch object is populated with the
       * passed batch id or use the currentBatch.  It is used by assigning it to a property in
       * the resolve object in a state configuration object.
       */
      var batchInfoResolver = [
        '$stateParams',
        '$rootScope',
        '$filter',
        'batchUtils',
        'MOBILE_EVENTS',
        function ($stateParams, $rootScope, $filter, batchUtils, MOBILE_EVENTS) {
          if (!batchUtils.currentBatch.status) {
            if ($stateParams.batchId) {
              return batchUtils.loadBatch($stateParams.batchId).then(function () {
                var batchDate = batchUtils.getTitleBatchDate();
                $rootScope.$emit(MOBILE_EVENTS.HEADER_CHANGE, {
                  title: batchDate
                });
                return batchUtils.currentBatch;
              });
            } else {
              // An empty object will result in a redirect to the admin page due to checks in the
              // controllers.
              return {};
            }
          } else {
            // The batch to display in the view.
            return batchUtils.currentBatch;
          }
        }
      ];

      $stateProvider
        .state(VIEW_STATES.MOBILE_BATCH, {
          abstract: true,
          resolve: {
            lastState: [
              '$state',
              function ($state) {
                var lastState = $state.current.name;
                return lastState;
              }
            ]
          },
          views: {
            content: {
              templateUrl: 'mobile/batch/batch.tpl.html',
              controller: 'MobileBatchMainCtrl'
            }
          }
        })
        // The views that are rendered in the batch view.
        .state(VIEW_STATES.MOBILE_BATCH_HOME, {
          url: 'mobile/batch/{batchId}',
          resolve: {
            // specifies a value that must be populated prior to loading the state.
            // This case will results in ensuring the batchUtils.currentBatch object is
            // populated.
            batchInfo: batchInfoResolver,
            orgInfo: [
              'accountUtils',
              function (accountUtils) {
                return accountUtils.getOrgInfo();
              }
            ]
          },
          views: {
            details: {
              templateUrl: 'mobile/batch/details/details.tpl.html',
              controller: 'MobileBatchDetailsCtrl'
            },
            info: {
              templateUrl: 'mobile/batch/info/info.tpl.html',
              controller: 'BatchInfoCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progressmobile.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The export view
        .state(VIEW_STATES.MOBILE_BATCH_EXPORT, {
          url: 'mobile/export/{batchId}',
          resolve: {
            batchInfo: batchInfoResolver
          },
          views: {
            info: {
              templateUrl: 'mobile/batch/export/info/exportInfo.tpl.html',
              controller: 'ExportInfoCtrl'
            },
            details: {
              templateUrl: 'mobile/batch/export/details/exportDetails.tpl.html',
              controller: 'ExportDetailsCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progressmobile.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The Object Restore view
        .state(VIEW_STATES.MOBILE_BATCH_OBJECT_RESTORE, {
          url: 'mobile/objectrestore/{batchId}',
          resolve: {
            batchInfo: batchInfoResolver
          },
          views: {
            info: {
              templateUrl: 'mobile/batch/objectRestore/info/objectRestoreInfo.tpl.html',
              controller: 'ObjectRestoreInfoCtrl'
            },
            details: {
              templateUrl: 'mobile/batch/objectRestore/details/objectRestoreDetails.tpl.html',
              controller: 'ObjectRestoreDetailsCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The Bulk Restore view
        .state(VIEW_STATES.MOBILE_BATCH_BULK_RESTORE, {
          url: 'mobile/bulkrestore/{batchId}',
          resolve: {
            batchInfo: batchInfoResolver
          },
          views: {
            info: {
              templateUrl: 'mobile/batch/bulkRestore/info/bulkRestoreInfo.tpl.html',
              controller: 'BulkRestoreInfoCtrl'
            },
            details: {
              templateUrl: 'mobile/batch/bulkRestore/details/bulkRestoreDetails.tpl.html',
              controller: 'MobileBulkRestoreDetailsCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The views that are rendered in the batch error view.
        .state(VIEW_STATES.MOBILE_BATCH_ERROR, {
          url: 'mobile/batch/{batchId}/error',
          resolve: {
            batchInfo: batchInfoResolver,
            orgInfo: [
              'accountUtils',
              function (accountUtils) {
                return accountUtils.getOrgInfo();
              }
            ]
          },
          views: {
            content: {
              templateUrl: 'mobile/batch/messages/messages.tpl.html',
              controller: 'BatchMessagesCtrl'
            }
          }
        });
    }
  ])
  /**
   * Controller for the abstract mobile batch view.  It only contains values that are
   * inherited and utilized by it's implementing views.
   */
  .controller('MobileBatchMainCtrl', [
    '$scope',
    'batchUtils',
    '$rootScope',
    'MOBILE_EVENTS',
    '$state',
    '$stateParams',
    '$filter',
    'BACKUP_STATE',
    'VIEW_STATES',
    function ($scope, batchUtils, $rootScope, MOBILE_EVENTS, $state, $stateParams, $filter, BACKUP_STATE, VIEW_STATES) {
      // Tie batchUtils to a local scope.
      $scope.batchUtils = batchUtils;

      /**
       * Error view click handler.  Used to navigate to an error detail view.
       */
      $scope.goToErrorView = function () {
        var errorMessage;

        if ($scope.batchUtils.currentBatch.errors !== 0) {
          errorMessage = $filter('pluralize')($scope.batchUtils.currentBatch.errors, 'SINGLE_ERROR', 'NUM_ERRORS');
        } else if ($scope.batchUtils.currentBatch.warnings !== 0) {
          errorMessage = $filter('pluralize')(
            $scope.batchUtils.currentBatch.warnings,
            'SINGLE_WARNING',
            'NUM_WARNINGS'
          );
        }

        $rootScope.$emit(MOBILE_EVENTS.HEADER_CHANGE, {
          title: errorMessage,
          previous: VIEW_STATES.MOBILE_HOME
        });

        return $state.go(VIEW_STATES.MOBILE_BATCH_ERROR);
      };

      // If the export progress state changes to false and the current batch is not in the finished state
      // then reload the current batch as it has finished then reload the state.
      $scope.$watch('exportInProgress ', function () {
        if (!$scope.exportInProgress && $scope.batchUtils.currentBatch.state !== BACKUP_STATE.FINISHED) {
          // if the original backupStatus was not Finished then load the batch.
          $scope.batchUtils.loadBatch($scope.stateParams.batchId).then(function () {
            $state.transitionTo($state.current, $state.params, {
              reload: true,
              inherit: false,
              notify: true
            });
          });
        }
      });
    }
  ]);
